module.exports = __webpack_public_path__ + "media/solitary-cry-of-a-pig.23a23612.mp3";